import { Navigate } from 'react-router-dom';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { LoginForm } from '../components/LoginForm';
import { useAuthStore } from '../stores/authStore';

export function LoginPage(): React.JSX.Element {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated());
  const isCompanyScoped = useAuthStore((state) => state.isCompanyScoped());
  const user = useAuthStore((state) => state.user);

  if (isAuthenticated) {
    const hasCandidate = user?.roles?.includes('CANDIDATE');
    if (hasCandidate) {
      return <Navigate to="/candidate/dashboard" replace />;
    }
    const redirectPath = isCompanyScoped ? '/agent/dashboard' : '/';
    return <Navigate to={redirectPath} replace />;
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-50 px-4">
      <Card className="w-full max-w-md">
        <CardHeader className="text-center">
          <CardTitle className="text-2xl">Welcome Back</CardTitle>
          <CardDescription>Sign in to your account to continue</CardDescription>
        </CardHeader>
        <CardContent>
          <LoginForm />
        </CardContent>
      </Card>
    </div>
  );
}
